class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-search-results]');
    this.abortController = null;

    if (!this.input || !this.results) return;

    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('focus', this.onInput.bind(this));

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        this.input.focus();
      }
    });
  }

  onInput() {
    const term = this.input.value.trim();

    if (term.length < 2) {
      this.close();
      return;
    }

    this.getResults(term);
  }

  async getResults(term) {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    const url = new URL(`${window.Shopify.routes.root}search/suggest`, window.location.origin);

    url.searchParams.set('q', term);
    url.searchParams.set('resources[type]', 'product,article,page');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('section_id', 'predictive-search');

    try {
      const response = await fetch(url.toString(), {
        signal: this.abortController.signal
      });

      if (!response.ok) throw new Error(response.status);

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const resultsMarkup = html.querySelector('#predictive-search-results');

      this.results.innerHTML = resultsMarkup ? resultsMarkup.outerHTML : '';

      if (this.results.textContent.trim()) {
        this.open();
      } else {
        this.close();
      }
    } catch (error) {
      if (error.name !== 'AbortError') this.close();
    }
  }

  open() {
    this.results.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.results.hidden = true;
    this.results.innerHTML = '';
    this.input.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('predictive-search', PredictiveSearch);